var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaskAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C7.58579 2 7.25 2.33579 7.25 2.75C7.25 3.16421 7.58579 3.5 8 3.5H9.0315C9.01094 3.57991 9 3.66368 9 3.75V9.42363C6.63505 10.5471 5 12.9576 5 15.75C5 19.616 8.13401 22.75 12 22.75C15.866 22.75 19 19.616 19 15.75C19 12.9576 17.3649 10.5471 15 9.42363V3.75C15 3.66368 14.9891 3.57991 14.9685 3.5H16C16.4142 3.5 16.75 3.16421 16.75 2.75C16.75 2.33579 16.4142 2 16 2H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaskAlt2);
export default __webpack_public_path__ + "static/media/flask-alt-2.29af5acd9f15cd9c1e56cbe5216de023.svg";
export { ForwardRef as ReactComponent };